/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_View_WeekInputs */

const en_plan_view_week = /** @type {(inputs: Plan_View_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Week`)
};

const de_plan_view_week = /** @type {(inputs: Plan_View_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Woche`)
};

/**
* | output |
* | --- |
* | "Week" |
*
* @param {Plan_View_WeekInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_view_week = /** @type {((inputs?: Plan_View_WeekInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_View_WeekInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_plan_view_week(inputs)
	return en_plan_view_week(inputs)
});